<template>
  <div id="b-cover" class="col-md-4 fullheight">
    <a href="http://archnadzor.ru/" target="_blank"
      ><img
        id="e-logo"
        :src="logoUrl"
        alt="Архнадзор"
        width="239"
        height="33"
    /></a>
    <h1 id="e-booktitle" class="booktitle" @click="toMainPage()">
      Красная<br />книга
    </h1>
    <h4>Карта тревожных адресов Москвы</h4>
  </div>
</template>

<script>
/** `public/i/archnadzor.png` → `${BASE_URL}i/archnadzor.png`. */
const logoUrl = `${import.meta.env.BASE_URL}i/archnadzor.png`;

export default {
  name: 'Cover',
  computed: {
    logoUrl() {
      return logoUrl;
    },
  },
  methods: {
    toMainPage() {
      this.$router.push('/map');
    },
  },
};
</script>
